import { Component, Input, OnInit } from '@angular/core';
import { AudioService } from 'src/app/services/audio/audio.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { GamesService } from 'src/app/services/lobby/games.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';


@Component({
  selector: 'app-game-tile-mobile',
  templateUrl: './game-tile-mobile.component.html',
  styleUrls: ['./game-tile-mobile.component.scss']
})
export class GameTileMobileComponent implements OnInit {

  @Input() gameData: string;
  public imagesPath: string;
  @Input() content: any;
  public isAuthenticated: boolean = false;


  constructor(
    private readonly galleryService: GalleryService,
    private readonly gamesService: GamesService,
    private readonly userSessionService: UserSessionService,
    private audioService: AudioService
  ) {
  }

  ngOnInit() {
    this.verifyAuth();
    this.imagesPath = this.galleryService.getGamesImagePath();
  }

  protected openGameDetailPage(gameData): any {
    this.audioService.playSound("GamePopupOpen")

    return this.galleryService.openGameDetailPage(gameData);
  }

  public verifyAuth(){
    this.userSessionService.isAuthenticated().then((res) => {
      if(res) this.isAuthenticated = true;
    });
  }

  public isFavourite(game_id) {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  scrollToTop(){
    this.content.nativeElement.scrollTo({
      left: 0,
      behavior: "smooth",
    });
 }

  public makeFavourite(gamedata, e) {
    this.scrollToTop();
    e.preventDefault();
    e.stopPropagation();
    //if(!this.isAuthenticated) return this.goToLogin()
    this.gamesService.addFavouritesAndRecreate(gamedata);
  }

  makeUnFavourite(game_id, e) {
    e.preventDefault();
    e.stopPropagation();
    //if(!this.isAuthenticated) return this.goToLogin()
    this.gamesService.removeFavouritesAndRecreate(game_id);
  }

}
